import { render, staticRenderFns } from "./VuesticIconRich.vue?vue&type=template&id=567bdc26&"
import script from "./VuesticIconRich.vue?vue&type=script&lang=js&"
export * from "./VuesticIconRich.vue?vue&type=script&lang=js&"
import style0 from "./VuesticIconRich.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticIconRich.vue"
export default component.exports